/* tslint:disable */
/* eslint-disable */
/**
 * SR AAT specification
 * Description
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Status } from './Status';
import {
    StatusFromJSON,
    StatusFromJSONTyped,
    StatusToJSON,
} from './Status';
import type { StatusCodes } from './StatusCodes';
import {
    StatusCodesFromJSON,
    StatusCodesFromJSONTyped,
    StatusCodesToJSON,
} from './StatusCodes';
import type { UpdateSite } from './UpdateSite';
import {
    UpdateSiteFromJSON,
    UpdateSiteFromJSONTyped,
    UpdateSiteToJSON,
} from './UpdateSite';

/**
 * 
 * @export
 * @interface UpdateSiteResponse
 */
export interface UpdateSiteResponse extends Status {
    /**
     * 
     * @type {UpdateSite}
     * @memberof UpdateSiteResponse
     */
    updatesite?: UpdateSite;
}

/**
 * Check if a given object implements the UpdateSiteResponse interface.
 */
export function instanceOfUpdateSiteResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function UpdateSiteResponseFromJSON(json: any): UpdateSiteResponse {
    return UpdateSiteResponseFromJSONTyped(json, false);
}

export function UpdateSiteResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateSiteResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        ...StatusFromJSONTyped(json, ignoreDiscriminator),
        'updatesite': !exists(json, 'updatesite') ? undefined : UpdateSiteFromJSON(json['updatesite']),
    };
}

export function UpdateSiteResponseToJSON(value?: UpdateSiteResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        ...StatusToJSON(value),
        'updatesite': UpdateSiteToJSON(value.updatesite),
    };
}

